<template>
  <v-dialog v-model="statusDialog" max-width="500">
    <v-card>
      <v-card-title>Email Sending Status</v-card-title>
      <v-card-text>
        {{ text }}
      </v-card-text>
      <v-card-text class="text-center">
        <v-progress-circular v-if="isLoad" indeterminate color="primary"></v-progress-circular>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="Close" :disabled="isLoad" @click="statusDialog = false">
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "StatusDialog",
  props: {
    isStatusDialog: Boolean,
    text: String,
    isLoad: Boolean,
  },
  computed: {
    statusDialog: {
      get() {
        return this.isStatusDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>